import React from 'react';
import './PublicConnect.scss';

/**
 * El marco de lo que ve el vendedor: la página del link y el resultado de la vuelta de Mercado Libre.
 * Sin el marco de la app ni login: una tarjeta centrada, pensada primero para un celular de 390 px
 * abierto desde WhatsApp. Liviano a propósito (sin reactstrap ni íconos registrados): los dos íconos
 * son SVG en línea.
 */
export function PublicConnectFrame({children}) {
    return (
        <main className="pcl-page">
            <div className="pcl-card">{children}</div>
        </main>
    );
}

const ICON_PATHS = {
    done: 'M9 12.5l2 2 4-4.5',
    error: 'M12 7.5v5.5M12 16.2v.3',
    soft: 'M8.5 12h7',
};

/** `kind`: `done` (verde), `error` (ámbar) o `soft` (gris). */
export function PublicStatusIcon({kind}) {
    return (
        <span className={`pcl-status-icon -${kind}`} aria-hidden="true">
            <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2.2"
                 strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d={ICON_PATHS[kind]}/>
            </svg>
        </span>
    );
}
